module.exports = __webpack_public_path__ + "img/diagram-project.017afd4a.svg";